import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20406 20406"
    {...props}
  >
    <path
      d="M20401 10203c-9937 144-10054 261-10198 10198-144-9937-262-10054-10199-10198C9941 10059 10059 9942 10203 4c144 9937 261 10054 10198 10199z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 599.904,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
